import type {CourseApiModel} from '../../../../api/course';
import type {MembershipExpandedCommon} from '../../../../api/membership';
import type {ProgramApiModel} from '../../../../api/program';

import {getEntityTypeById} from '../../../../utils/entity/getEntityType';
import {isProgramGroup} from '../../../../utils/entity/program';
import {AcceptGroupRequestedMembershipsStrategy} from './AcceptGroupRequestedMembershipsStrategy';
import {AcceptIndividualRequestedMembershipsStrategy} from './AcceptIndividualRequestedMembershipsStrategy';
import {InviteToAnotherCourseStrategy} from './InviteToAnotherCourseStrategy';
import {InviteToAnotherProgramStrategy} from './InviteToAnotherProgramStrategy';

type Config = {
  memberships: MembershipExpandedCommon[];
  target?: CourseApiModel | ProgramApiModel;
};

export class AcceptRequestedMembershipStrategyFactory {
  static create({memberships, target}: Config) {
    const targetType = target ? getEntityTypeById(target._id) : null;

    if (targetType === 'program') {
      return new InviteToAnotherProgramStrategy({
        memberships,
        target: target as ProgramApiModel,
      });
    }

    if (targetType === 'course') {
      return new InviteToAnotherCourseStrategy({
        memberships,
        target: target as CourseApiModel,
      });
    }

    if (isProgramGroup(memberships[0]!.program)) {
      return new AcceptGroupRequestedMembershipsStrategy({
        memberships,
      });
    } else {
      return new AcceptIndividualRequestedMembershipsStrategy({
        memberships,
      });
    }
  }
}
